import { render, staticRenderFns } from "./ActionShow.vue?vue&type=template&id=082a8654&scoped=true&"
import script from "./ActionShow.vue?vue&type=script&lang=js&"
export * from "./ActionShow.vue?vue&type=script&lang=js&"
import style0 from "./ActionShow.vue?vue&type=style&index=0&id=082a8654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082a8654",
  null
  
)

export default component.exports